import { VCombobox } from 'vuetify/lib'
import { defaultFun } from '../utils'
import { COMBOBOX } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: COMBOBOX,
    mixins: [ commonMixins ],
    render(h) {
        const {
                         // eslint-disable-next-line 
                         slots,scopedSlots,
             key,
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
            if (params.attach === undefined) {
                params.attach = true
            }
        return h(VCombobox, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                value: this.my_value[key]
            },
            on: {
                blur,
                change:(data) => {
                    this.my_value[key] = data
                    change(data)
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup,
            }
        })
    }
}